import { type JSX, createContext, useContext } from "solid-js";

import { DialogType } from "./types";

const DialogContext = createContext<DialogType | undefined>();

export function DialogProvider(props: {
  dialogType: DialogType;
  children: JSX.Element;
}) {
  return (
    <DialogContext.Provider value={props.dialogType}>
      {props.children}
    </DialogContext.Provider>
  );
}

export function useDialogContext() {
  return useContext(DialogContext);
}
